import React, { useState } from "react";
import styled from "styled-components";

import { dateFormat } from "../helper";
import Button from "./ui/Button";
import ButtonGroup from "./ui/ButtonGroup";
import Field, { Wrapper as FieldWrapper } from "./ui/Field";
import Flatpickr from "./ui/Flatpickr";

const Wrapper = styled.div`
  padding: 40px;
  
  & > *:not(form) {
    color: white;
  }

  & + & {
    padding-top: 0;
  }

  ${FieldWrapper} + ${FieldWrapper} {
    margin-top: 20px;
  }
`;

const BookRoom = ({ optionalPanels }) => {
  const { book_a_room_content: content, etch_hotel_id: hotelCode } = optionalPanels;
  
  const today = (new Date()).toISOString().split("T")[0];

  const [state, setState] = useState({
    checkIn: today,
  })

  const handleCheckInChange = (date) => {
    setState((previousState) => ({ ...previousState, checkIn: date }));
  }

  const handleCheckOutChange = (date) => {
    setState((previousState) => ({ ...previousState, checkOut: date }));
  }

  return (
    <>
      <Wrapper dangerouslySetInnerHTML={{
          __html: content,
        }}
      />
      <Wrapper>
        <form action="https://www.youngshotels.co.uk/book/stay/guests" method="get" _lpchecked="1" target="_blank">
          <input type="hidden" name="hotelCode" id="hotelCode" value={hotelCode} />
          <Field label="Check In" value={state.checkIn ? dateFormat(state.checkIn) : 'Select Date'}>
            <Flatpickr defaultDate={state.checkIn} handleChange={handleCheckInChange} minDate={today}>
              <input name="checkin" type="text" />
            </Flatpickr>
          </Field>
          <Field label="Check Out" value={state.checkOut ? dateFormat(state.checkOut) : 'Select Date'}>
            <Flatpickr defaultDate={state.checkOut} handleChange={handleCheckOutChange} minDate={today}>
              <input name="checkout" type="text" />
            </Flatpickr>
          </Field>
          <ButtonGroup>
            <Button active>
              Check Availability
            </Button>
          </ButtonGroup>
        </form>
      </Wrapper>
    </>
  );
};

export default BookRoom;
